#import "../../WorkgroupGroupFields.graphql"
mutation WorkgroupGroupCreate($input: WorkgroupGroupCreateInput!) {
  workgroupGroupCreate(input: $input) {
    workgroupGroup {
      ...WorkgroupGroupFields
    }
  }
}
